import { render, staticRenderFns } from "./AdminLeadView.vue?vue&type=template&id=bcd8ff24"
import script from "./AdminLeadView.vue?vue&type=script&lang=js"
export * from "./AdminLeadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports